import { generatePath } from 'react-router';
import { call, put, select, take, takeLatest } from 'redux-saga/effects';

import { SELECT_DEALER } from 'constants/ActionTypes';
import { PATH } from 'constants/RoutesConstants';
import { scopeToPage } from 'modules/app/sagas/utils';
import { FETCH_GROUP_FAILURE, FETCH_GROUP_SUCCESS, SELECT_GROUP } from 'modules/groups/actionTypes';
import { getSelectedGroupId } from 'modules/groups/selectors';
import { navigate } from 'modules/router/navigate';
import { isGroupManagement as isGroup } from 'modules/router/selectors';
import * as actions from 'modules/screensaver/actions/core';
import * as types from 'modules/screensaver/actionTypes';
import { getFormattedFilters } from 'modules/screensaver/selectors/dashboard';

import { SCREENSAVER_DASHBOARD } from '../constants';

function* refreshScreenSaversDashboard() {
  const payload = yield select(getFormattedFilters);
  yield put(actions.fetchScreenSavers(payload, { target: SCREENSAVER_DASHBOARD }));
}

/** @param {import("../types/actions").CloneScreensaverSuccessAction} action */
function* afterCloneWorker({ payload: screensaver }) {
  const { id: screensaverId, dealerId } = screensaver;
  const { path } = dealerId ? PATH.DEALER_CONFIG_SCREENSAVER_DETAILS : PATH.GROUP_CONFIG_SCREENSAVER_DETAILS;
  yield call(navigate, generatePath(path, { screensaverId }));
}

const REFRESH_ACTIONS = [types.SET_SCREENSAVERS_DASHBOARD_FILTER, types.CLEAR_SCREENSAVERS_DASHBOARD_FILTER];

function* onPageWorker() {
  const isGroupManagement = yield select(isGroup);
  const groupId = yield select(getSelectedGroupId);
  if (!groupId) {
    yield take([FETCH_GROUP_SUCCESS, FETCH_GROUP_FAILURE]);
  }

  yield call(refreshScreenSaversDashboard);
  yield takeLatest(types.CLONE_SCREENSAVER_SUCCESS, afterCloneWorker);
  yield takeLatest([isGroupManagement ? SELECT_GROUP : SELECT_DEALER, ...REFRESH_ACTIONS], refreshScreenSaversDashboard);
}

const DASHBOARD_PATH = [PATH.GROUP_CONFIG_SCREENSAVERS, PATH.DEALER_CONFIG_SCREENSAVERS];

export default function* screensaverDashboardSaga() {
  yield scopeToPage(DASHBOARD_PATH, onPageWorker);
}
